import { zodResolver } from "@hookform/resolvers/zod";
import { Box } from "@mui/material";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { SelectInput } from "@components/FormControl";
import TextArea from "@components/FormControl/TextArea";
import Modal from "@components/Modal";

import "../../RegistrationProgressComponents/Modals/styles.scss";

const reasonOptions = [
  "Want to reschedule for a different time",
  "Did not fully understand service and do not want to proceed",
  "Out-of-network or insurance cost too high",
  "Decided to see a provider in-person",
  "Did not want to enter a credit card",
].map((v) => ({ label: v, value: v }));

const formValidationSchema = z.object({
  reason: z.string(),
  cancelDescription: z.string(),
});

type FormValues = z.infer<typeof formValidationSchema>;

const CancelModal = ({
  onDelete,
  onClose,
}: {
  onDelete: (formValues: FormValues) => void;
  onClose: () => void;
}) => {
  const { handleSubmit, control, watch } = useForm<FormValues>({
    resolver: zodResolver(formValidationSchema),
    defaultValues: {
      reason: "",
      cancelDescription: "",
    },
  });

  const reason = watch("reason");
  return (
    <Modal
      open={true}
      title="Cancel Appointment"
      bodyParagraphs={[
        "This will permanently cancel your appointment and you will have to reschedule for a different time. Do you wish to continue?",
      ]}
      buttons={[
        {
          variant: "contained",
          label: "Cancel Appointment",
          onClick: handleSubmit((data) => onDelete(data)),
          disabled: !reason,
        },
        {
          variant: "text",
          label: "Return",
          onClick: onClose,
        },
      ]}
    >
      <Box width="100%">
        <SelectInput
          name="reason"
          label="Reason"
          size="small"
          control={control}
          options={reasonOptions}
          sx={{ textAlign: "left", pb: 0 }}
        />
        <TextArea
          name="cancelDescription"
          label="Description"
          placeholder="Description"
          size="small"
          control={control}
        />
      </Box>
    </Modal>
  );
};

export default CancelModal;
